export const GREEN = "#00793A";
export const BLACK = "#333333";
export const WHITE = "#FFFFFF";
export const ORANGE = "#F19425";
export const GREY = "#999999";
export const LIGHT_GREY = "#F2F2F2";
export const LIGHT_GREY_2 = "#CCCCCC";
